module.exports = __webpack_public_path__ + "img/logo2.4501c0f2.png";